import React from 'react';
import './style.css';

const Birthday: React.FC = () => {
  return (
    <div className="omoge-birthday">
      <div className="heading">
        <h1>Happy Birthday Aduke Mi <span role="img" aria-label="confetti">🎉🥳</span></h1>
        <p>There are 24 balloons here, one for each year of your birth.</p>
        <br />
        <p>
          My babyyyyyyyyyy, I hope you have the best time today.
          I pray that all your heart desires come to pass.
        </p>
        <p>
          The other day you asked me how loving you felt like and I never gave you an answer.
          <br />
          Well there is only one way to describe it.
          I feel like spiderman.
          <br />
          Loving you makes me feel powerful, it makes me feel like i can do anything i want to do in this life and take on any thing and anyone.
          It strengthens me in ways that even I don't really understand.
          This might sound cliche but sometimes i feel like i could fly.
          There is a warmth that comes from being with you and a feeling of still waters when we're together.
          I love how warm your hugs feel, i love how you smile when you tease me or when you're giddy about something.
          I love your smile so much and your smile will always be beautiful to me every night and day.
          It constantly warms my heart whenever I can make you smile or happy at the slightest, it's the most peaceful feeling and I give myself a thumbs up every time.
        </p>
        <p>
          I love you so much Aduke mi, so so much.
          <br />
          I can't wait to spend more birthdays with you and celebrate you more.
          <br />
          I can't wait to see you grow into the woman you want to be.
          <br />
          I can't wait to see you achieve all your dreams and goals.
          <br />
          I can't wait to see you smile more and more.
          <br />
          I can't wait to see you happy more and more.
          <br />
          I can't wait to see you love more and more.
          <br />
          I can't wait to see you grow more and more.
          <br />
          I can't wait to see you shine more and more.
        </p>
        <p>
          Happy birthday my love <span role="img" aria-label="heart">❤️</span>
        </p>
      </div>
    </div>
  );
};

export default Birthday;
